import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import MultiSelectBox from '../../../../../features/components/Form/MultiSelectBox'

import { formatOptionsList } from '../../../../../features/formatters'
import { createJsonFromQueryString } from '../../../../../helpers/url'

import { getProductsService } from '../../../../../modules/services/mediaOrdersProducts'
import { selectedControllerIdSelector } from '../../../../../modules/selectors/app'

import { MEDIA_PRODUCTS } from '../../fields'

const MediaProductsPaginatedMultiSelect = ({ formik, limit = 20 }) => {
  const { values, setFieldValue, errors, touched } = formik
  const controllerId = useSelector(selectedControllerIdSelector)

  const formatOptions = useCallback(
    options =>
      formatOptionsList({
        list: options,
        valueName: 'id',
        labelName: 'name'
      }),
    []
  )

  const loadOptions = useCallback(
    async (search, loadedOptions, { next }) => {
      const response = await getProductsService({
        search,
        ordering: 'name',
        controller: controllerId,
        fields: ['id', 'name'].join(','),
        limit,
        ...createJsonFromQueryString(`?${next.split('?')[1]}`)
      })

      const newProductsOptions = formatOptions(response.results)

      return {
        options: newProductsOptions,
        hasMore: !!response.next,
        additional: {
          next: response.next
        }
      }
    },
    [controllerId, formatOptions, limit]
  )

  return (
    <MultiSelectBox
      placeholder="Select products"
      name={MEDIA_PRODUCTS}
      value={values[MEDIA_PRODUCTS]}
      error={errors[MEDIA_PRODUCTS]}
      touched={touched[MEDIA_PRODUCTS]}
      loadOptions={loadOptions}
      setFieldValue={setFieldValue}
      expandMenu={true}
      portaled={true}
    />
  )
}

MediaProductsPaginatedMultiSelect.propTypes = {
  formik: PropTypes.object.isRequired,
  limit: PropTypes.number
}

export default MediaProductsPaginatedMultiSelect
